document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initResenasCarrusel();
  initCuentaAtras();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidadProducto();
});

function initReveal() {
  var els = document.querySelectorAll('.cl-reveal');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach(function (el) { el.classList.add('cl-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cl-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el, i) {
    el.style.setProperty('--cl-stagger', i % 6);
    observer.observe(el);
  });
}

function initResenasCarrusel() {
  document.querySelectorAll('[data-cl-resenas]').forEach(function (wrap) {
    var track = wrap.querySelector('.cl-resenas__track');
    var prev = wrap.querySelector('[data-cl-prev]');
    var next = wrap.querySelector('[data-cl-next]');
    if (!track) return;
    function scrollByCard(dir) {
      var card = track.querySelector('.cl-resena');
      var gap = 20;
      var amount = card ? card.getBoundingClientRect().width + gap : 300;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });
  });
}

function initCuentaAtras() {
  document.querySelectorAll('[data-cl-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-cl-countdown'));
    if (isNaN(target.getTime())) return;
    var dEl = el.querySelector('[data-cl-days]');
    var hEl = el.querySelector('[data-cl-hours]');
    var mEl = el.querySelector('[data-cl-mins]');
    var sEl = el.querySelector('[data-cl-secs]');
    function tick() {
      var now = new Date();
      var diff = target.getTime() - now.getTime();
      if (diff < 0) diff = 0;
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var mins = Math.floor((diff / (1000 * 60)) % 60);
      var secs = Math.floor((diff / 1000) % 60);
      if (dEl) dEl.textContent = days;
      if (hEl) hEl.textContent = String(hours).padStart(2, '0');
      if (mEl) mEl.textContent = String(mins).padStart(2, '0');
      if (sEl) sEl.textContent = String(secs).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-cl-galeria]').forEach(function (galeria) {
    var main = galeria.querySelector('[data-cl-galeria-principal]');
    var thumbs = galeria.querySelectorAll('[data-cl-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        if (src) {
          main.src = src;
          main.alt = alt;
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-cl-producto]').forEach(function (root) {
    var dataEl = root.querySelector('[data-cl-variantes-json]');
    if (!dataEl) return;
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var idInput = root.querySelector('[data-cl-variant-id]');
    var priceNow = root.querySelector('[data-cl-price-now]');
    var priceWas = root.querySelector('[data-cl-price-was]');
    var addBtn = root.querySelector('[data-cl-add]');
    var pillGroups = root.querySelectorAll('[data-cl-option-index]');

    function currentSelection() {
      var sel = [];
      pillGroups.forEach(function (group) {
        var active = group.querySelector('.cl-pill.is-selected');
        sel.push(active ? active.getAttribute('data-value') : null);
      });
      return sel;
    }

    function findVariant(selection) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selection[i]; });
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateAvailability() {
      pillGroups.forEach(function (group, groupIndex) {
        group.querySelectorAll('.cl-pill').forEach(function (pill) {
          var value = pill.getAttribute('data-value');
          var sel = currentSelection();
          sel[groupIndex] = value;
          var match = variants.some(function (v) {
            return v.options.every(function (opt, i) {
              return sel[i] == null || opt === sel[i];
            });
          });
          pill.disabled = !match;
        });
      });
    }

    function render() {
      var sel = currentSelection();
      var variant = findVariant(sel);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceNow) priceNow.textContent = formatMoney(variant.price);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = formatMoney(variant.compare_at_price);
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
      }
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-label-add');
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-label-soldout');
        }
      }
      updateAvailability();
    }

    pillGroups.forEach(function (group) {
      group.querySelectorAll('.cl-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.disabled) return;
          group.querySelectorAll('.cl-pill').forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          render();
        });
      });
    });

    render();
  });
}

function initCantidadProducto() {
  document.querySelectorAll('[data-cl-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-cl-qty-minus]');
    var plus = wrap.querySelector('[data-cl-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
    });
  });
}
